// Brand-agnostic colour tokens.
//
// These are deliberately the same for every brand: the destination hero is a fixed dark
// surface, and the chart series are a data-visualisation palette chosen for category
// separation, not for brand expression. They live here rather than in a brand file so a
// sub-brand host cannot silently inherit another brand's values.
//
// Anything that should change per brand belongs in the theme palette instead — reference
// it as an sx path ('primary.main') so it resolves per request.

// destination page
export const DESTINATION_HERO_BG = '#1a2332'
export const DESTINATION_HERO_OVERLAY = 'rgba(26, 35, 50, 0.82)'
export const DESTINATION_HERO_TEXT_MUTED = 'rgba(255, 255, 255, 0.6)'
export const DESTINATION_HERO_TEXT_SECONDARY = 'rgba(255, 255, 255, 0.75)'
export const DESTINATION_HERO_TEXT_PRIMARY = 'rgba(255, 255, 255, 0.85)'
export const DESTINATION_HERO_CHIP_BG = 'rgba(255, 255, 255, 0.12)'
export const DESTINATION_HERO_CHIP_BORDER = 'rgba(255, 255, 255, 0.2)'
export const DESTINATION_HERO_SEARCH_SHADOW = '0 8px 32px rgba(0, 0, 0, 0.3)'
export const DESTINATION_HOTEL_CARD_OVERLAY = 'rgba(0, 0, 0, 0.45)'

// chart / data-visualisation
export const CHART_TEMP_HIGH = '#F97316'
export const CHART_TEMP_LOW = '#0EA5E9'
export const CHART_RAINFALL = '#93C5FD'
export const CHART_BAR_FARE = '#91D2DC'
export const CHART_AXIS_LABEL = '#64748B'
export const CHART_GRID_LINE = '#E2E8F0'
